"use client";

import { c as _c } from "react/compiler-runtime";
import type { MouseEvent } from "react";
import { getLinkTarget, isModifiedClick } from "@/components/Link/link.utilities";
import { RegularLink, type RegularLinkProps } from "@/components/Link/RegularLink.component";
import { isArticleUrl, isExternalUrl } from "@/utilities/url/url-utilities";
import { useAppBridge } from "@/vendors/webview/bridge/hooks/use-app-bridge";
export type WebviewArticle = {
  readonly id: string;
  readonly sectionTitle?: string;
  readonly imageUrl?: string;
};
type WebviewLinkProps = RegularLinkProps & {
  readonly webviewArticle?: WebviewArticle;
};
export function WebviewLink(t0) {
  const $ = _c(18);
  let href;
  let linkProps;
  let onClick;
  let t1;
  let webviewArticle;
  if ($[0] !== t0) {
    ({
      onClick,
      href,
      openInNewTab: t1,
      webviewArticle,
      ...linkProps
    } = t0);
    $[0] = t0;
    $[1] = href;
    $[2] = linkProps;
    $[3] = onClick;
    $[4] = t1;
    $[5] = webviewArticle;
  } else {
    href = $[1];
    linkProps = $[2];
    onClick = $[3];
    t1 = $[4];
    webviewArticle = $[5];
  }
  const openInNewTab = t1 === undefined ? false : t1;
  const {
    navigateToPage,
    navigateToArticle
  } = useAppBridge();
  let t2;
  if ($[6] !== href || $[7] !== navigateToArticle || $[8] !== navigateToPage || $[9] !== onClick || $[10] !== openInNewTab || $[11] !== webviewArticle) {
    t2 = event => {
      onClick?.(event);
      if (event.defaultPrevented || isModifiedClick(event)) {
        return;
      }
      const target = getLinkTarget(href, openInNewTab);
      if (target === "_blank" || isExternalUrl(href)) {
        return;
      }
      event.preventDefault();
      if (webviewArticle && isArticleUrl(href)) {
        navigateToArticle({
          id: webviewArticle.id,
          imageUrl: webviewArticle.imageUrl,
          sectionTitle: webviewArticle.sectionTitle,
          url: href
        });
      } else {
        navigateToPage(href);
      }
    };
    $[6] = href;
    $[7] = navigateToArticle;
    $[8] = navigateToPage;
    $[9] = onClick;
    $[10] = openInNewTab;
    $[11] = webviewArticle;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  const handleClick = t2;
  let t3;
  if ($[13] !== handleClick || $[14] !== href || $[15] !== linkProps || $[16] !== openInNewTab) {
    t3 = <RegularLink {...linkProps} href={href} onClick={handleClick} openInNewTab={openInNewTab} />;
    $[13] = handleClick;
    $[14] = href;
    $[15] = linkProps;
    $[16] = openInNewTab;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  return t3;
}